module.exports = __webpack_public_path__ + "static/video2_MP4-3c2135c1564fae37f717fa5696fe2790.mp4";